module.exports = __webpack_public_path__ + "static/headerIcon-7c9a6455d1f6bc1b5465dbd7955a4c50.svg";